import React from "react";
import styled from "@emotion/styled";

const StyledImg = styled.img(
  ({
    imgWidth,
    imgHeight,
    round,
    objectFit,
    bgColor,
    radius,
    aspectRatio,
  }) => ({
    minWidth: imgWidth ? imgWidth : "100%",
    minHeight: imgHeight ? imgHeight : "100%",
    width: imgWidth ? imgWidth : "100%",
    height: imgHeight ? imgHeight : "100%",
    borderRadius: round ? "50%" : radius ? radius : "",
    objectFit: objectFit ? objectFit : "",
    backgroundColor: bgColor ? bgColor : "",
    aspectRatio: aspectRatio ? aspectRatio : "",
  })
);

const Image = ({
  src,
  width,
  height,
  round,
  alt,
  objectFit,
  bgColor,
  onClick,
  radius,
  aspectRatio,
}) => {
  return (
    <StyledImg
      src={src}
      imgWidth={width}
      imgHeight={height}
      round={round}
      radius={radius}
      alt={alt}
      objectFit={objectFit}
      bgColor={bgColor}
      onClick={onClick}
      aspectRatio={aspectRatio}
    />
  );
};

export default Image;
